import { useMemo } from 'react';

import { useUserExperiments } from '~hooks/queries/users/query';
import { useUserId } from '~hooks/useUserId';

import { EXPERIMENT_VARIANTS } from '../constants';
import { UseExperimentResult } from '../types';

export function useExperiment(experimentKey: string): UseExperimentResult {
  const userId = useUserId();
  const { data: userExperiments, isLoading } = useUserExperiments({ userId });

  const variant = useMemo(() => {
    return userExperiments?.Data?.data?.find((exp) => exp.experimentKey === experimentKey)?.variant;
  }, [userExperiments, experimentKey]);

  const isControl = useMemo(() => variant === EXPERIMENT_VARIANTS.CONTROL, [variant]);
  const isTreatment = useMemo(() => variant === EXPERIMENT_VARIANTS.TREATMENT, [variant]);
  const abTestLogValue = useMemo(() => {
    const experiments = userExperiments?.Data?.data;
    if (!experiments) return undefined;
    const obj = experiments.reduce<Record<string, string | undefined>>(
      (acc, { experimentKey, variant }) => ({ ...acc, [experimentKey]: variant }),
      {},
    );
    return JSON.stringify(obj);
  }, [userExperiments]);

  return {
    variant,
    isControl,
    isTreatment,
    isLoading,
    abTestLogValue,
  };
}
